<style lang="scss" scoped>
.error-msg {
    display: flex;
    margin-bottom: 8px;
    .error-icn {
        width: 20px;
        height: 20px;
        background: var(--danger);
        color: #fff;
        display: block;
        border-radius: 3px;
        text-align: center;
        line-height: 20px;
        flex: none;
        margin-right: 15px;
    }
    .error-txt {
        color: var(--danger);
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>

<template>
    <div v-if="error">
        <transition-group name="fade">
            <div v-for="e in compiledErrors" :key="`${e.message}_error`" class="error-msg d-flex flex-none small">
                <span class="error-icn my-auto">!</span>
                <div class="error-txt my-auto">{{ $t(`errors.${e.message}`, [e.field, ...e.params]) }}</div>
            </div>
        </transition-group>
    </div>
</template>

<script>
export default {
    name: "components.forms.el_error",

    props: {
        error: {
            default: false
        }
    },

    computed: {
        compiledErrors() {
            if (!this.error) return [];

            if (typeof error_tmp === "string") return [this.error];

            return this.error.errors;
        }
    }
};
</script>
